import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  selectedSuperBatchSelector,
  setSelectedSuperBatch,
} from 'features/classCreation';
import { SUPER_BATCH_TYPES } from 'data/superBatchTypes';
import Field from 'components/Field';
import styles from './SelectSecondaryAndCrashCourseBatch.module.scss';
import SuperBatchSelect from 'components/SuperBatchSelect';

const SelectSecondaryAndCrashCourseBatch = () => {
  const dispatch = useDispatch();
  const selectedSuperBatch = useSelector(selectedSuperBatchSelector);

  const handleSuperBatchChange = useCallback(
    (option) => {
      dispatch(setSelectedSuperBatch(option));
    },
    [dispatch]
  );

  return (
    <Field
      label="Search Batch"
      className="m-b-m"
    >
      <SuperBatchSelect
        className={styles.selectGroup}
        value={selectedSuperBatch}
        batchTypes={[
          SUPER_BATCH_TYPES.secondary,
          SUPER_BATCH_TYPES.crashCourse,
        ]}
        onChange={handleSuperBatchChange}
      />
    </Field>
  );
};

export default SelectSecondaryAndCrashCourseBatch;
